import api from 'api/apiInstance';

export function usersSignOutApi(path: string) {
  return {
    path,
    DELETE: () => api.delete(path),
  };
}
